export default ['permission', 'currentFacility', 'currentAccountId', 'currentPrinter'];
